var _rect, _circle, _circle2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandscapeMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 343,
    viewBox: "0 0 672 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 340.166,
    width: 337.666,
    height: 666.766,
    rx: 53.5,
    transform: "rotate(-90 2.5 340.166)",
    fill: "#FFECE5",
    stroke: "#4D313D",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 628.867,
    cy: 171.333,
    r: 24.601,
    transform: "rotate(-90 628.867 171.333)",
    stroke: "#4D313D",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.4415,
    cy: 203.062,
    r: 5.3373,
    transform: "rotate(-90 44.4415 203.062)",
    fill: "#4D313D",
    stroke: "#4D313D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9417,
    y: 190.445,
    width: 56.1783,
    height: 7,
    rx: 3.5,
    transform: "rotate(-90 40.9417 190.445)",
    fill: "#4D313D",
    stroke: "#4D313D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapeMobile);
export default __webpack_public_path__ + "static/media/landscape-mobile.a05d81cdf561cdbc790cbc2da1f31df7.svg";
export { ForwardRef as ReactComponent };